import { render, staticRenderFns } from "./set-password.page.vue?vue&type=template&id=65aca2fc&scoped=true&"
import script from "./set-password.page.vue?vue&type=script&lang=js&"
export * from "./set-password.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aca2fc",
  null
  
)

export default component.exports